import request from "../service/request"
// 最新汇率
export const GetExchangeList = (params)=> request.post('/erp/newExchange',params)
// 历史汇率
export const GetHistoryeList = (params)=> request.post('/erp/allExchange',params)
export const GetDataType = (params)=> request.post('/erp/dropdownList',params)